/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/style-prop-object */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useNebula from 'hooks/useNebula';

// import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
// import useQlikSessionObject from 'hooks/useQlikSessionObject';
import useStyles from './styles';
import TranslationTxt from '../TranslationTxt/TranslationTxt';

// import AppContext from '../AppContext';

const MapSection = ({ header, text }) => {
  const classes = useStyles();

  const nebula = useNebula();
  //   const { qlikApp } = useContext(AppContext);
  const mapRef = useRef();

  useEffect(async () => {
    if (!nebula) return;
    mapRef.current = await nebula.render({
      type: 'map',
      element: mapRef.current,
      options: {
        configuration: {
          // serverUrl: 'https://maps.qlikcloud.com',
          // serverKey: '123456',
        },
      },
      // id: '1c8c34ce-ba79-4545-9df0-0fc206af426f',
      properties: {
        gaLayers: [
          {
            type: 'PointLayer',
            qHyperCubeDef: {
              qDimensions: [
                {
                  qDef: {
                    qFieldDefs: [
                      '1c8c34ce-ba79-4545-9df0-0fc206af426f',
                    ],
                  },
                  qAttributeExpressions: [
                    {
                      qExpression: 'latitude',
                      id: 'locationOrLatitude',
                    },
                    {
                      qExpression: 'longitude',
                      id: 'longitude',
                    },
                  ],
                },
              ],
              qMeasures: [],
              qInitialDataFetch: [
                {
                  qLeft: 0,
                  qTop: 0,
                  qWidth: 1,
                  qHeight: 10000,
                },
              ],
            },
            size: {
              radiusMin: 4,
              radiusMax: 12,
            },
            color: {
              mode: 'primary',
              paletteColor: {
                index: 9,
                color: '#f8981d',
              },
            },
            locationOrLatitude: {
              key: 'latitude',
              type: 'expression',
            },
            isLatLong: true,
            id: 'tWTdanX',
          },
        ],
        mapSettings: {
          showScaleBar: true,
        },
      },
    });
  }, [nebula]);

  return (
    <div className="section" style={{ marginBottom: 50, marginTop: 50 }}>
      <Typography variant="h3" className={classes.header}>
        <TranslationTxt measure={header} />
      </Typography>
      <Typography variant="body1" className={classes.text}>
        <TranslationTxt measure={text} />
      </Typography>
      {/* <div className={classes.mapViz} ref={mapRef} style={{ height: 500 }} /> */}
      <iframe
        src="https://sense-demo.qlik.com/single/?appid=d2ac234f-68cd-4f18-b77d-a399bdabbffc&obj=PeRtpMT"
        style={{
          border: 'none', width: '100%', height: '600px', backgroundColor: 'transparent !important',
        }}
      />
    </div>
  );
};

MapSection.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
};

MapSection.defaultProps = {
  header: '',
  text: '',
};

export default MapSection;
